// CountDown.jsx

import React, { useEffect, useState } from "react";
import styled from "styled-components";

const CountdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: ${({ theme }) => theme.background_secondary};
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;

  @media (max-width: 640px) {
    gap: 12px;
  }

  @media (max-width: 320px) {
    gap: 0.5em;
  }

  

  // position: absolute;
  // bottom: 0em;
`;

const CountdownItem = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
  font-size: 35px;
  font-weight: bold;
  min-width: 2em;

  background-color: rgba(128, 128, 128, 0.5);
  border-radius: 0.2em;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  color: ${({ theme }) => theme.text_primary};
  
  @media (max-width: 426px) {
    font-size: 1.6em;
    min-width: 2.2em;
  }

  @media (max-width: 375px) {
    font-size: 1.5em;
    height: 50px;
  }

  @media (max-width: 320px) {
    font-size: 1.5em;
    height: 50px;
  }

  span {
    position: relative;
    font-size: 17px;
    font-weight: bold;
    bottom: 5px;
    
    color: ${({ theme }) => theme.text_secondary};

    @media (max-width: 425px) {
      font-size: 0.5em;
      bottom: 5px;
    }

    @media (max-width: 320px) {
      font-size: 0.65em;
      bottom: 10px;
    }
  }
`;

const Sep = () => {
  const P = styled.p`
    font-size: 2em;
    color: white;
    font-weight: bold;

    @media (max-width: 320px) {
      font-size: 1.5em;
    }
  `;
  
  return <P>:</P>;
};

const calculateTimeLeft = (eventDate) => {
  const now = new Date().getTime();
  const difference = eventDate - now;

  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000),
    };
  }

  return timeLeft;
};

const CountDown = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate));
  
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <CountdownWrapper>
      <CountdownItem>
        <p>{timeLeft.days !== undefined ? `${timeLeft.days}` : '0'}</p>
        <span>Days</span>
      </CountdownItem>

      <Sep />

      <CountdownItem>
        <p>{timeLeft.hours !== undefined ? `${timeLeft.hours}` : '0'}</p>
        <span>Hrs</span>
      </CountdownItem>
      
      <Sep />

      <CountdownItem>
        <p>{timeLeft.minutes !== undefined ? `${timeLeft.minutes}` : '0'}</p>
        <span>Mins</span>
      </CountdownItem>

      <Sep />
      
      <CountdownItem>
        <p>{timeLeft.seconds !== undefined ? `${timeLeft.seconds}` : '0'}</p>
        <span>Secs</span>
      </CountdownItem>
    </CountdownWrapper>
  );
};

export default CountDown;
